import { useEffect, useContext, useState, useRef } from "react";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import Grid from "@mui/material/Grid";
import AuthContext from "../context/auth/AuthContext";
import Loader from "../components/Loader";
import Header from "../layouts/Header";
import {
  calculatePaymentScore,
  clearPaymentData,
  haveValue,
  LANDLORD_PATHS,
  toast,
} from "../helper/common";
import NewWorkspaceLayout from "../components/Workspace/NewWorkspaceLayout";
import WelcomeModal from "../components/Workspace/WelcomeModal";
import Flag from "../assets/img/flag.svg";
import i18next from "i18next";
import { Modal } from "react-bootstrap";
import LandLordContext from "../context/landlord/LandLordContext";
import useTranslator from "../hooks/useTranslator";
import CreateNewWorkspaceModal from "../components/Workspace/CreateNewWorkspaceModal";
import { WORKSPACE_ROLES_CAPABILITIES } from "../Utils/workspaceRoleCapabilities";
import WorkspaceInviationModal from "../components/Workspace/WorkspaceInviationModal";
import Joyride, { EVENTS, STATUS } from "react-joyride";
import PendingApplicationsModal from "../components/Workspace/PendingApplicationsModal";
import { getTenantShareRequests } from "../services/sharedService";

const Homepage = () => {
  const { _t } = useTranslator();
  const authContext = useContext(AuthContext);
  const {
    loadUser,
    loading,
    user,
    userType,
    changeUserLng,
    logout,
    toggleNewWorkspaceModal,
    openNewWorkspaceModal,
    loadUserTenant,
  } = authContext;
  const navigate = useNavigate();
  const childRef = useRef(null);
  const { workspaceId } = useParams();
  const location = useLocation();
  const { fetchWorkspaceInvites, tourCompleted, fetchWorkspacesOverview } =
    useContext(LandLordContext);
  const [shouldCreateWorkspace, setShouldCreateWorkspace] = useState(true);
  const queryParam = new URLSearchParams(window.location.search);
  const userToken = queryParam.get("userToken");
  let account_verification_report_id = queryParam.get(
    "account_verification_report_id"
  );
  const [searchParams, setSearchParams] = useSearchParams();
  let transaction_report_id = queryParam.get("transaction_report_id");

  const [isSidebarCollapse, setIsSidebarCollapse] = useState(false);
  const [isSidebarClicked, setIsSidebarClicked] = useState(false);
  const [currentWorkspace, setCurrentWorkspace] = useState({});
  const [openWelcomeModal, setOpenWelcomeModal] = useState(false);
  const [tempWorkspaceData, setTempWorkspaceData] = useState({});
  const [inviteIndex, setInviteIndex] = useState(0);
  const [manageMembers, setManageMembers] = useState({
    id: "",
    isOpen: false,
  });
  const [allowWrap, setAllowWrap] = useState(false);
  const [agencyDetails, setAgencyDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const [pendingInvites, setPendingInvites] = useState([]);
  const [isManageWorkspaceModal, setIsManageWorkspaceModal] = useState(false);
  const [isWorkspaceInvitationModal, setIsWorkspaceInvitationModal] =
    useState(false);
  const [workspaceTab, setWorkspaceTab] = useState("settings");
  const thresholdPx = 250;
  const thresholdVw = (thresholdPx / 1440) * 100;
  const vw = (px) => (px / window.innerWidth) * 100;
  const [stepIndex, setStepIndex] = useState(0);
  const [tutorialSteps, setTutorialSteps] = useState(false);
  const [pendingStepIndex, setPendingStepIndex] = useState(null);
  const [workspaceName, setWorkspaceName] = useState("");
  const [openWorkspaceModal, setOpenWorkspaceModal] = useState(true);
  const [openInviteModal, setOpenInviteModal] = useState(false);
  const isSidebarNavigation = useRef(false);
  const [showPendingApplicationsModal, setShowPendingApplicationsModal] =
    useState(false);
  const [pendingApplicationsData, setPendingApplicationsData] = useState([]);
  const [pendingApplicationsLoading, setPendingApplicationsLoading] =
    useState(false);
  const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
  const [allWorkspaces, setAllWorkspaces] = useState([]);

  useEffect(() => {
    const shouldOpen =
      searchParams.get("new_application") === "true" ||
      searchParams.get("new_application") === "1";

    getTenantShareRequests()
      .then((res) => {
        if (shouldOpen) {
          setShowPendingApplicationsModal(true);
        }
        const data =
          res?.success_res?.applications || res?.success_res || res?.data || [];
        setPendingApplicationsData(Array.isArray(data) ? data : []);
        setPendingRequestsCount(Array.isArray(data) ? data.length : 0);
      })
      .catch((err) => {
        console.log(err);
        toast.error(_t("errorWhileFetchingDashboardNotifications"));
      })
      .finally(() => {
        setPendingApplicationsLoading(false);
      });
  }, [searchParams]);

  useEffect(() => {
    if ((user?.workspaceIds ?? [])?.length === 0) {
      return;
    }
    // loadData();
    Promise.all([fetchWorkspacesOverview()])
      .then(([workspaceRes]) => {
        setAllWorkspaces(workspaceRes?.success_res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user?._id, user?.workspaceIds?.length]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const openEditableTab = params.get("openEditableTab");

    if (openEditableTab === "invitations" || openEditableTab === "billing") {
      setWorkspaceTab(openEditableTab);
      setIsManageWorkspaceModal(true);

      // Clean param using navigate (NOT replaceState)
      params.delete("openEditableTab");

      navigate(
        {
          pathname: location.pathname,
          search: params.toString() ? `?${params.toString()}` : "",
        },
        { replace: true }
      );
    }
  }, [location.search]);

  useEffect(() => {
    let token = localStorage.getItem("token");
    let usertype = localStorage.getItem("usertype");
    if (token && usertype) {
      loadUser(usertype);
      let sharedpath = localStorage.getItem("sharedurl");
      if (usertype === "tenant" && sharedpath) {
        window.location.href = sharedpath;
      }
    } else {
      if (haveValue(queryParam.get("gurantorFor"))) {
        navigate("/guarantor/auth");
        return;
      } else if (haveValue(queryParam.get("requestProfileLink"))) {
        navigate("/tenant/auth");
        return;
      } else if (haveValue(queryParam.get("applications"))) {
        navigate("/tenant/auth");
        return;
      } else if (
        LANDLORD_PATHS.includes(location.pathname) ||
        location?.search?.includes("?workspace_invite=")
      ) {
        navigate("/landlord/auth");
        return;
      } else if (
        userToken &&
        account_verification_report_id &&
        transaction_report_id
      ) {
        calculateScore(
          userToken,
          account_verification_report_id,
          transaction_report_id
        );
        return;
      } else {
        const hash = location.hash;
        const path =
          hash === "#landlord"
            ? "/landlord"
            : hash === "#tenant"
              ? "/tenant"
              : "";
        navigate(`${path}/auth`);
        if (hash) {
          window.history.replaceState(
            null,
            "",
            window.location.pathname + window.location.search
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    if (!user?.workspaceIds || !workspaceId) return;
    const workspaceFromUrl = user?.workspaceIds?.filter(
      (val) => val?.uuid === workspaceId
    );
    setCurrentWorkspace(workspaceFromUrl?.[0] || null);
    return () => {
      setCurrentWorkspace(null);
    };
  }, [workspaceId, user?.workspaceIds]);

  useEffect(() => {
    if (user?.role === "landlord") {
      fetchWorkspaceInvites()
        .then((res) => {
          setPendingInvites(res?.success_res?.workspacePending);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [user?.workspaceIds]);

  useEffect(() => {
    const isMobile = window.innerWidth <= 667;

    if (isMobile) {
      setTutorialSteps(false);
      return;
    }
    if (haveValue(user) && !user?.tourCompleted) {
      setTutorialSteps(true);
    }
  }, [user?.tourCompleted]);

  const calculateScore = async (
    userToken,
    accountverificationid,
    transactionreportid
  ) => {
    account_verification_report_id = null;
    transaction_report_id = null;
    await clearPaymentData(userToken);

    calculatePaymentScore(
      userToken,
      accountverificationid,
      transactionreportid
    );
  };

  const handleChangeWorkspace = (workspaceObj) => {
    if (
      location.pathname?.includes("profile-request") ||
      location.pathname?.includes("created-tenant") ||
      location.pathname?.includes("payment/property/list")
    ) {
      navigate(location.pathname.replace(/^\/[^/]+/, `/${workspaceObj?.uuid}`));
    } else if (location.pathname?.includes("profile-property")) {
      const previousPath = location.state?.from;
      console.log("navigated from here", previousPath);

      if (previousPath) {
        const newPath = previousPath.replace(
          /^\/[^/]+/,
          `/${workspaceObj?.uuid}`
        );

        navigate(newPath);
      } else {
        // fallback if no previous path exists
        navigate(`/${workspaceObj?.uuid}/profile-request`);
      }
    } else {
      if (location.pathname?.includes("workspace-dashboard")) {
        navigate(`/${workspaceObj?.uuid}/profile-request`);
      } else {
        navigate(`/${workspaceObj?.uuid}`);
      }
    }
    goToStepNinth();
    loadUserTenant("landlord");
  };

  const handleMemebersList = (e, workspaceId) => {
    e.stopPropagation();
    setManageMembers({
      id: workspaceId,
      isOpen: true,
    });
  };

  const handleCloseWelcome = () => {
    setOpenWelcomeModal(false);
  };

  const takeMeToProfile = () => {
    console.log("here it is");
    navigate(`/${userType}-profile`);
  };

  const handleLanguageChange = async (langVal) => {
    await i18next.changeLanguage(langVal);
    await changeUserLng();
    setCurrentLang(langVal);
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (vw(e.clientX) > thresholdVw && !isSidebarClicked) {
        setIsSidebarCollapse(false);
      }
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [isSidebarClicked]);

  useEffect(() => {
    if (isSidebarCollapse) {
      const id = setTimeout(() => setAllowWrap(true), 700);
      return () => clearTimeout(id);
    }

    setAllowWrap(false);
  }, [isSidebarCollapse]);

  const closePendingApplicationsModal = () => {
    setShowPendingApplicationsModal(false);
    const nextSearch = new URLSearchParams(searchParams);
    nextSearch.delete("new_application");
    setSearchParams(nextSearch, { replace: true });
  };

  const handlePendingApplicationsRefresh = () => {
    window.dispatchEvent(new CustomEvent("profiles-refresh"));
  };

  const isTenantCheckPage =
    location?.pathname && String(location.pathname).includes("/tenant-check");
  const { pathname } = useLocation();

  const hideContainer =
    pathname.includes("generatedReport") ||
    pathname.includes("report-overview") ||
    pathname.includes("capacity-report") ||
    pathname.includes("linked-report-overview");

  const canProceed = (index) => {
    if (index === 4) {
      return !!workspaceName?.length;
    }
    return true;
  };

  // onboarding-tutorial
  const rawTutorialSteps = [
    // step 1
    {
      target: ".homeIcon",
      placement: "right",
      disableBeacon: true,
      content: (
        <div className="joyride-container">
          <h2 className="joyride-heading">{_t("welcomeToWorkspaces")}</h2>
          <p className="joyride-text">
            {_t(
              "weHaveIntroducedWorkspacesToHelpYouOrganizeYourWorkMoreFlexiblyThisIsYourNewHomePageWhereYouCanSeeAllTheWorkspacesYouBelongToAndYourRecentNotifications"
            )}
          </p>
        </div>
      ),
    },
    // step 2
    {
      target: ".workspaceInnerContainerWrapper",
      placement: "right",
      disableBeacon: true,
      content: (
        <div className="joyride-container">
          <h2 className="joyride-heading">{_t("whatChanges")}</h2>
          <p className="joyride-text">
            {_t("aWorkspaceReplacesTheOldAccountLevelSetup")}
          </p>
          <p className="joyride-text">
            {_t("itHelpsYouOrganizePropertiesTenantsAndMembersByTeamOrProject")}
          </p>
        </div>
      ),
    },
    // step 3
    {
      target: ".default-manage-workspace",
      placement: "bottom",
      disableBeacon: true,
      content: (
        <div className="joyride-container">
          <h2 className="joyride-heading">{_t("howIsItOrganized")}</h2>
          <p className="joyride-text">{_t("yourDefaultWorkspaceIsAtTheTop")}</p>
          <p className="joyride-text">
            {_t(
              "belowAreTheWorkspaceYouCreatedOrJoinedFollowedByAnOptionToCreateANewWorkspace"
            )}
          </p>
        </div>
      ),
    },
    // step 4
    {
      target: ".additional-workspace",
      placement: "bottom",
      disableBeacon: true,
      content: (
        <div className="joyride-container">
          <h2 className="joyride-heading">{_t("letsCreateAnExample")}</h2>
          <p className="joyride-text">
            {_t("letsCreateAnAdditionalWorkspaceAsAnExample")}
          </p>
          <p className="joyride-text">
            {_t("youCanUseWorkspacesToSeparateTeamsPortfoliosOrProjects")}
          </p>
        </div>
      ),
    },
    // step 5
    {
      target: "#manage-member-walkthrough .modal-content",
      placement: "right",
      disableBeacon: true,
      styles: {
        buttonNext: {
          pointerEvents: canProceed(4) ? "auto" : "none",
          opacity: canProceed(4) ? 1 : 0.4,
        },
      },
      content: (
        <div className="joyride-container">
          <h2 className="joyride-heading">{_t("appearanceSetUp")}</h2>
          <p className="joyride-text">
            {_t("startByChoosingANameAndAnIconForYourworkspace")}
          </p>
        </div>
      ),
    },
    // step 6
    {
      target: "#invite-member-walkthrough .modal-content",
      placement: "right",
      disableBeacon: true,
      content: (
        <div className="joyride-container">
          <h2 className="joyride-heading">{_t("manageAccess")}</h2>
          <p className="joyride-text">
            {_t(
              "youCanInviteAdditionalMembersAndAssignDifferentAccessLevelsOrSimplyCreateTheWorkspaceAndStartManagingYourProperties"
            )}
          </p>
        </div>
      ),
    },
    // step 7
    {
      target: "#welcome-modal-walkthrough .modal-content",
      placement: "right",
      disableBeacon: true,
      hideBackButton: true,
      content: (
        <div className="joyride-container">
          <h2 className="joyride-heading">{_t("workspaceCreated")}</h2>
          <p className="joyride-text">
            {_t("youHaveSuccessfullyCreatedYourFirstWorkspace")}
          </p>
        </div>
      ),
    },
    // step 8
    {
      target: ".workspace-wrapper",
      placement: "right",
      disableBeacon: true,
      hideBackButton: true,
      content: (
        <div className="joyride-container">
          <h2 className="joyride-heading">{_t("activeWorkspaces")}</h2>
          <p className="joyride-text">
            {_t(
              "everythingYouSeeNowOutOfTheLeftPanelBelongsToThisWorkspacePleaseSelectAWorkspaceToContinue"
            )}
          </p>
        </div>
      ),
    },
    // step 9
    {
      target: ".tutorial-properties-share-button",
      placement: "right",
      disableBeacon: true,
      content: (
        <div className="joyride-container">
          <h2 className="joyride-heading">{_t("shareProperties")}</h2>
          <p className="joyride-text">
            {_t(
              "inThePropertiesTabUseThisButtonToManagePropertiesAcrossWorkspacesYouCanAddAPropertyToAnotherWorkspaceOrRemoveItFromTheCurrentOne"
            )}
          </p>
          <ul>
            <li>
              <p className="joyride-text">
                {_t("deletingAPropertyRemovesItFromAllWorkspaces")}
              </p>
            </li>
            <li>
              <p className="joyride-text">
                {_t("awardingAPropertyAppliesToAllWorkspacesWhereItExists")}
              </p>
            </li>
          </ul>
        </div>
      ),
    },
    // step 10
    {
      target: "body",
      placement: "center",
      disableBeacon: true,
      content: (
        <div className="joyride-container">
          <h2 className="joyride-heading">{_t("allSet")}</h2>
          <p className="joyride-text">
            {_t("youCanSwitchWorkspacesAnytimeFromTheSidebar")}
          </p>
          <p className="joyride-text">
            {_t("ifYouHaveAnyQuestionsFeelFreeToContactUs")}
          </p>
        </div>
      ),
    },
  ];

  const TutorialSteps = rawTutorialSteps.map((step, index) => ({
    ...step,
    content: (
      <div className="joyride-content-wrapper">
        <div className="joyride-step-left">
          {index + 1} / {rawTutorialSteps.length}
        </div>

        <div className="joyride-main-content">{step.content}</div>
      </div>
    ),
  }));

  const goToStepFour = () => {
    if (!tutorialSteps) return;
    setStepIndex(4);
  };
  const goToStepFive = () => {
    if (!tutorialSteps) return;
    setStepIndex(5);
  };
  const goToStepSix = () => {
    if (!tutorialSteps) return;
    setStepIndex(6);
  };
  const goToStepSeven = () => {
    if (!tutorialSteps) return;
    setStepIndex(7);
  };
  const goToStepEight = () => {
    if (!tutorialSteps) return;
    setStepIndex(8);
  };
  const goToStepNinth = () => {
    if (!tutorialSteps) return;
    setStepIndex(9);
  };
  const goToPrevStep = (stepsBack = 1) => {
    if (!tutorialSteps) return;

    setIsSidebarCollapse(true);
    setIsSidebarClicked(true);

    setTimeout(() => {
      setStepIndex((prev) => {
        const nextStep = Math.max(prev - stepsBack, 0);
        return nextStep;
      });
    }, 550);
  };

  useEffect(() => {
    if (pendingStepIndex !== null) {
      const id = setTimeout(() => {
        setStepIndex(pendingStepIndex);
        setPendingStepIndex(null);
      }, 350);

      return () => clearTimeout(id);
    }
  }, [pendingStepIndex]);

  const handleJoyrideCallback = async (data) => {
    const { index, type, action, status } = data;

    /* =========================
     NEXT BUTTON
     ========================= */
    if (type === EVENTS.STEP_AFTER && action === "next") {
      const nextIndex = index + 1;

      console.log("called this", index);
      if (index === 3 && action === "next") {
        toggleNewWorkspaceModal(true);
      }

      if (index === 6 && action === "next") {
        setOpenWelcomeModal(false);
        goToStepEight();
      }

      if (index === 5 && action === "next" && shouldCreateWorkspace) {
        childRef.current?.handleSubmit();
      }

      if (index === 7 && action === "next") {
        if (!isSidebarNavigation.current) {
          handleChangeWorkspace(user?.workspaceIds[0]);
        }
        isSidebarNavigation.current = false;
      }

      // RESET UI
      setIsSidebarCollapse(false);
      setIsSidebarClicked(false);
      setIsManageWorkspaceModal(false);

      // SIDEBAR STEPS (1 & 2)
      if (
        nextIndex === 1 ||
        nextIndex === 2 ||
        nextIndex === 3 ||
        nextIndex === 4 ||
        nextIndex === 5
      ) {
        setIsSidebarCollapse(true);
        setIsSidebarClicked(true);

        setTimeout(() => {
          setStepIndex(nextIndex);
        }, 450);
        return;
      }
      setStepIndex(nextIndex);
    }

    /* =========================
     BACK BUTTON
     ========================= */

    if (type === EVENTS.STEP_AFTER && action === "prev" && index - 1 === 4) {
      setOpenInviteModal(false);
      setOpenWorkspaceModal(true);
      // goToPrevStep()
    }
    if (type === EVENTS.STEP_AFTER && action === "prev" && index - 1 === 5) {
      setOpenInviteModal(true);
      setOpenWelcomeModal(false);
      goToPrevStep();
    }
    if (type === EVENTS.STEP_AFTER && action === "prev" && index - 1 !== 5) {
      const prevIndex = index - 1;
      if (prevIndex === 3) {
        toggleNewWorkspaceModal(false);
      }

      // RESET UI
      setIsSidebarCollapse(false);
      setIsSidebarClicked(false);
      setIsManageWorkspaceModal(false);

      // BACK TO SIDEBAR STEPS (1 & 2)
      if (prevIndex === 1 || prevIndex === 2 || prevIndex === 3) {
        setIsSidebarCollapse(true);
        setIsSidebarClicked(true);

        setTimeout(() => {
          setStepIndex(prevIndex);
        }, 450);
        return;
      }
      if (prevIndex === 9) {
        setTimeout(() => {
          setStepIndex(3);
        }, 250);
      }

      // NORMAL BACK
      setStepIndex(prevIndex);
    }

    /* =========================
     FINISH / SKIP
     ========================= */
    if (
      status === STATUS.FINISHED ||
      status === STATUS.SKIPPED ||
      status === STATUS.CLOSED ||
      action === "close" ||
      type === EVENTS.TOUR_END
    ) {
      setIsSidebarCollapse(false);
      setIsSidebarClicked(false);
      setIsManageWorkspaceModal(false);
      setTutorialSteps(false);
      setStepIndex(0);
      setPendingStepIndex(null);
      await tourCompleted();
    }
  };

  return (
    <>
      <Joyride
        steps={TutorialSteps}
        run={tutorialSteps}
        stepIndex={stepIndex}
        showProgress={false}
        continuous
        disableBeacon
        disableScrolling
        showCloseButton
        disableOverlayClose
        disableCloseOnEsc
        spotlightClicks={true}
        callback={handleJoyrideCallback}
        locale={{
          last: _t("done"),
          next: _t("next"),
          back: _t("back"),
          skip: _t("skip"),
        }}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
      />
      <div
        onClick={() => {
          setIsSidebarCollapse(false);
          setIsSidebarClicked(false);
          setIsProfileDropdown(false);
        }}
      >
        {loading ? (
          <>
            <div id="main-app-loader">
              <Loader />
            </div>
          </>
        ) : null}

        {localStorage.getItem("usertype") === "landlord" &&
          !isTenantCheckPage && (
            <>
              <div
                style={hideContainer ? { display: "none" } : {}}
                className={`sidebarMain ${
                  isSidebarCollapse ? "sidebarMainFullWidth" : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsProfileDropdown(false);
                }}
              >
                <div
                  className={`${
                    !tutorialSteps && "workspaceInnerContainerWrapper-scroll"
                  } workspaceInnerContainerWrapper ${
                    allowWrap ? "wrap-enabled" : "nowrap"
                  }`}
                >
                  <div
                    className={`workspaceInnerContainer workspace-dashboard-tutorial align-items-center cursor-pointer workspaceInnerContainerActive ${
                      location.pathname.includes("workspace-dashboard")
                        ? "workspaceInnerContainerActive-border"
                        : ""
                    }`}
                    onClick={() => navigate("/workspace-dashboard")}
                  >
                    <div
                      className={`workspaceName homeIcon d-flex align-items-center justify-content-center`}
                      style={{
                        background: !location.pathname.includes(
                          "workspace-dashboard"
                        )
                          ? "rgba(242, 242, 242, 1)"
                          : "#253738",
                      }}
                    >
                      <img
                        src={
                          !location.pathname.includes("workspace-dashboard")
                            ? "/images/home-icon-grey.svg"
                            : "/images/home-icon-light-green.svg"
                        }
                        alt=""
                      />
                    </div>
                    {isSidebarCollapse && (
                      <div className="workspaceInfo w-100">
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <h3>{_t("home")}</h3>
                        </div>
                      </div>
                    )}
                  </div>

                  {pendingRequestsCount > 0 ? (
                    <div
                      className="workspaceInnerContainer pending-application-btn-wrapper workspace-dashboard-tutorial align-items-center cursor-pointer workspaceInnerContainerActive"
                      onClick={() => {
                        setPendingApplicationsLoading(true);
                        setSearchParams({ new_application: "true" });
                      }}
                    >
                      <button
                        className="pending-application-btn"
                        disabled={
                          pendingApplicationsLoading ||
                          pendingRequestsCount === 0
                        }
                      >
                        <img
                          src="/images/user-add-icon.svg"
                          alt="User Pending"
                        />
                        {pendingApplicationsLoading ? (
                          <span className="three-dots-loader">
                            <span></span>
                            <span></span>
                            <span></span>
                          </span>
                        ) : pendingRequestsCount !== 0 ? (
                          <span className="bg-danger workspace-notification-count text-white rounded-pill d-flex align-items-center justify-content-center count-wrapper">
                            {pendingRequestsCount}
                          </span>
                        ) : null}
                      </button>
                      {isSidebarCollapse && (
                        <div className="workspaceInfo w-100">
                          <div className="d-flex align-items-center justify-content-between w-100">
                            <h3>{_t("pendingRequests")}</h3>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : null}
                  <div className="workspace-wrapper">
                    {user?.workspaceIds?.map((workspace, index) => (
                      <div
                        className={` ${
                          index == 0 ? "default-manage-workspace" : ""
                        } workspaceInnerContainer cursor-pointer workspaceInnerContainerActive ${
                          currentWorkspace?._id?.toString() ===
                          workspace?._id?.toString()
                            ? "workspaceInnerContainerActive-border"
                            : ""
                        }`}
                        onClick={() => {
                          isSidebarNavigation.current = true;
                          handleChangeWorkspace(workspace);
                        }}
                      >
                        <div
                          style={{
                            backgroundColor:
                              haveValue(workspace?.workspaceImage) &&
                              "transparent",
                          }}
                          className={`${
                            index == 0 ? "default-workspace" : ""
                          } workspaceName d-flex align-items-center justify-content-center`}
                        >
                          {haveValue(workspace?.workspaceImage) ? (
                            <img src={`${workspace?.workspaceImage}`} alt="" />
                          ) : (
                            <h4>{workspace.name?.substring(0, 1)}</h4>
                          )}
                          {/* CONDITION FOR ALLOWING TOP USER TO EDIT AND ONLY CURRENT WORKSPACE ONLY */}

                          {currentWorkspace?._id?.toString() ===
                            workspace?._id?.toString() &&
                            WORKSPACE_ROLES_CAPABILITIES?.manageWorkspace?.includes(
                              user?.current_workspace_role
                            ) &&
                            user?.current_workspace?._id?.toString() ===
                              currentWorkspace?._id?.toString() && (
                              <div
                                onClick={() => {
                                  setWorkspaceTab("settings");
                                  setIsManageWorkspaceModal(true);
                                }}
                                className="workspace-hover-overlay"
                              >
                                <img src="/images/edit-icon.svg" />
                              </div>
                            )}
                        </div>
                        {isSidebarCollapse && (
                          <div className="workspaceInfo w-100">
                            <div className="d-flex align-items-center justify-content-between w-100">
                              <div>
                                <h6>
                                  {index == 0 &&
                                  user?.workspaceIds?.[0]?.created_by?.toString() ===
                                    user?._id?.toString()
                                    ? _t("defaultWorkspace")
                                    : (() => {
                                        const hasDefault =
                                          user?.workspaceIds?.[0]?.created_by?.toString() ===
                                          user?._id?.toString();
                                        return `${_t("workspace")} ${hasDefault ? index : index + 1}`;
                                      })()}
                                </h6>
                                <h3>{workspace.name}</h3>
                              </div>
                              {currentWorkspace?._id?.toString() ===
                                workspace?._id?.toString() && (
                                <img
                                  src="/images/checkmark-green.svg"
                                  alt="Checkmark"
                                />
                              )}
                            </div>
                            {currentWorkspace?._id?.toString() ===
                              workspace?._id?.toString() &&
                              WORKSPACE_ROLES_CAPABILITIES?.manageMembers?.includes(
                                user?.current_workspace_role
                              ) && (
                                <div
                                  className="membersCountWrapper"
                                  onClick={(e) => {
                                    setWorkspaceTab("members");
                                    handleMemebersList(e, workspace?._id);
                                  }}
                                >
                                  <img
                                    src="/images/multiUserIcon.svg"
                                    alt="Users Icon"
                                  />
                                  <p>{_t("manageMembers")}</p>
                                  <span className="dot" />
                                  <h5>
                                    {
                                      user?.workspaceLandlordCounts?.[
                                        workspace?._id
                                      ]
                                    }
                                  </h5>
                                  <img
                                    src="/images/arrow-right-gray.svg"
                                    alt="Users Icon"
                                    className="arrowRight"
                                  />
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                    ))}
                    {pendingInvites?.length > 0 && (
                      <hr className="workspace-divider" />
                    )}
                    {pendingInvites?.length > 0 &&
                      pendingInvites?.map((val, index) => (
                        <>
                          <div
                            onClick={() => {
                              setIsWorkspaceInvitationModal(true);
                              setInviteIndex(index);
                            }}
                            className="workspaceInnerContainer position-relative cursor-pointer"
                          >
                            <div className="pending-wrokspace d-flex align-items-center justify-content-center">
                              <h4>{val?.workspaceId?.name?.substring(0, 1)}</h4>
                            </div>
                            <span className="Pending-tag">{_t("pending")}</span>
                            {isSidebarCollapse && (
                              <div className="workspaceInfo w-100">
                                <div className="d-flex align-items-center justify-content-between w-100">
                                  <div>
                                    <h6>
                                      {_t("invitationPendingForWorkspace")}
                                    </h6>
                                    <h3>{val?.workspaceId?.name}</h3>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      ))}
                  </div>
                  <WorkspaceInviationModal
                    isOpen={isWorkspaceInvitationModal}
                    onClose={() => setIsWorkspaceInvitationModal(false)}
                    inviteData={pendingInvites[inviteIndex]}
                    setTempWorkspaceData={setTempWorkspaceData}
                    setOpenWelcomeModal={setOpenWelcomeModal}
                  />
                </div>
                <div
                  className="d-flex workspaceNameWrapper additional-workspace align-items-center justify-content-start custom-gap-3 cursor-pointer"
                  onClick={() => {
                    toggleNewWorkspaceModal(true);
                    if (tutorialSteps) {
                      goToStepFour();
                    }
                  }}
                >
                  <div
                    className="workspaceName workspace-add-icon d-flex align-items-center justify-content-center"
                    style={{ background: "#253837" }}
                  >
                    <img src="/images/add-green.svg" />
                  </div>
                  {isSidebarCollapse && <h3>{_t("addNewWorkspace")}</h3>}
                </div>

                <Link
                  to="/help"
                  className="d-flex help-tutorial-button workspaceNameWrapper align-items-center justify-content-start custom-gap-3 cursor-pointer"
                >
                  <a
                    className={`tutorial-help-icon d-flex align-items-center justify-content-center ${pathname === "/help" ? "active" : ""}`}
                  >
                    <img src="/images/help-circle.svg" />
                  </a>
                  {isSidebarCollapse && <h3>{_t("helpAndTutorials")}</h3>}
                </Link>
              </div>
              <div
                style={hideContainer ? { display: "none" } : {}}
                className="slideryt mt-auto"
              >
                <div className="re-div d-flex align-items-center justify-content-center">
                  <div className="dropdown admin-btn">
                    <div className="d-flex gap-3 cursor-pointer admin-btn-inner">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsProfileDropdown(!isProfileDropdown);
                        }}
                        className="admin-name header-admin-name"
                      >
                        {userType == "landlord" ? (
                          haveValue(agencyDetails) &&
                          haveValue(agencyDetails?.company_name) &&
                          haveValue(agencyDetails?.company_logo) ? (
                            <img
                              id="navbar_ll_image"
                              src={`${agencyDetails?.company_logo}`}
                              alt=""
                            />
                          ) : (
                            <>
                              {WORKSPACE_ROLES_CAPABILITIES?.nonGuestRoles?.includes(
                                user?.current_workspace_role
                              )
                                ? `${
                                    user?.fname_companyName &&
                                    user?.fname_companyName
                                      .charAt(0)
                                      .toUpperCase()
                                  }${
                                    user?.lname &&
                                    user?.lname.charAt(0).toUpperCase()
                                  }`
                                : "G"}
                            </>
                          )
                        ) : (
                          <>
                            {user?.fname && user?.fname.charAt(0).toUpperCase()}
                            {user?.lname && user?.lname.charAt(0).toUpperCase()}
                          </>
                        )}
                      </div>
                    </div>

                    {isProfileDropdown && (
                      <div className="hover-dropdown-mobile hover-dropdown profile-dropdown">
                        {userType === "tenant" && (
                          <Link onClick={() => navigate("/edit-basic-info")}>
                            <img src="/images/edit-icon-white.svg" alt="" />{" "}
                            {_t("editProfile")}
                          </Link>
                        )}
                        <div
                          className="cursor-pointer btn-view-profile"
                          onClick={(e) => {
                            takeMeToProfile();
                          }}
                        >
                          <img src="/images/eye-icon.svg" alt="" />{" "}
                          {_t("viewProfile")}
                        </div>
                        <Link className="" onClick={(e) => setShowModal(true)}>
                          <img src="/images/logout-icon.svg" alt="" />{" "}
                          {_t("logout")}
                        </Link>
                        <div
                          className="language-switch-mobile pb-0 hideOnDesktop"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {currentLang == "es" ? (
                            <div
                              className="language-switch-container language-switch-container-es cursor-pointer"
                              onClick={(e) => handleLanguageChange("en-us")}
                            >
                              <p>ES</p>
                              <img
                                className="flag-image me-0"
                                alt="Flag"
                                src="/images/spain-flag.png"
                              />
                            </div>
                          ) : (
                            <div
                              className="language-switch-container cursor-pointer"
                              onClick={(e) => handleLanguageChange("es")}
                            >
                              <img
                                className="flag-image me-0"
                                alt="Flag"
                                src={Flag}
                              />
                              <p>EN</p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <Modal
                  show={showModal}
                  centered
                  className="newmodalui wrapper-modal asguarantor"
                >
                  <Modal.Header></Modal.Header>
                  <Modal.Body>
                    <div className="forminput forminput-btngrp row100">
                      {_t("areYouSureYouWantToLogout")}
                    </div>
                    <div className="btngroup row100 gridbar">
                      <button
                        className="btn btnoutline cancel-btn"
                        type="button"
                        onClick={(e) => setShowModal(false)}
                      >
                        {_t("cancel")}
                      </button>
                      <button
                        className="btn btnorange"
                        type="button"
                        onClick={logout}
                      >
                        {_t("logout")}
                      </button>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </>
          )}
        {!hideContainer &&
          !location.pathname?.includes("/tenant-check/create") &&
          !location.pathname?.includes("/edit-basic-info") && (
            <Header
              isSidebarCollapse={isSidebarCollapse}
              setIsSidebarCollapse={setIsSidebarCollapse}
              isSidebarClicked={isSidebarClicked}
              setIsSidebarClicked={setIsSidebarClicked}
              currentWorkspace={currentWorkspace}
            />
          )}

        <Grid container spacing={0}>
          <Grid item lg={12} sm={12} md={12} xs={12}>
            <div
              className={` ${!hideContainer && !location.pathname?.includes("/edit-basic-info") && "margin-div"} ${
                location.pathname?.includes("/profile-property") ||
                location.pathname?.includes("/notification") ||
                location.pathname === "/tenant/review/rental" ||
                location.pathname?.includes("/payment/property/list") ||
                location.pathname?.includes(
                  "/payment/details/:assingedPropId"
                ) ||
                location.pathname?.includes("/sub/landlords") ||
                location.pathname.includes("/profile-request") ||
                location.pathname === "/kelify" ||
                location.pathname?.includes("/addidealist") ||
                location.pathname?.includes("/credits-ledger") ||
                location.pathname?.includes("/tenant-check/create") ||
                location.pathname === "/tenant-bank-verification" ||
                location.pathname?.includes("/created-tenant") ||
                location.pathname?.includes("/home") ||
                (location.pathname?.includes("/home") &&
                  localStorage.getItem("usertype") == "tenant")
                  ? "skorlist_main"
                  : ""
              } ${
                localStorage.getItem("usertype") == "landlord"
                  ? `${!hideContainer && "sidebarCollapseMain"}`
                  : ""
              } ${isTenantCheckPage ? "noSidebar" : ""}
            `}
            >
              <Outlet />
            </div>
          </Grid>
        </Grid>
        {openNewWorkspaceModal && (
          <NewWorkspaceLayout
            goToPrevStep={goToPrevStep}
            goToStepFour={goToStepFour}
            goToStepFive={goToStepFive}
            goToStepSix={goToStepSix}
            setCloseState={toggleNewWorkspaceModal}
            setOpenWelcomeModal={setOpenWelcomeModal}
            setTempWorkspaceData={setTempWorkspaceData}
            workspaceName={workspaceName}
            setWorkspaceName={setWorkspaceName}
            // step={stepIndex === 5}
            // isSixthStep={stepIndex === 6}
            currentStep={stepIndex}
            openWorkspaceModal={openWorkspaceModal}
            setOpenWorkspaceModal={setOpenWorkspaceModal}
            openInviteModal={openInviteModal}
            setOpenInviteModal={setOpenInviteModal}
            childRef={childRef}
            setShouldCreateWorkspace={setShouldCreateWorkspace}
          />
        )}
        {openWelcomeModal && (
          <WelcomeModal
            goToStepEight={goToStepEight}
            isOpen={openWelcomeModal}
            onClose={handleCloseWelcome}
            workspaceData={tempWorkspaceData}
          />
        )}
        {(isManageWorkspaceModal || manageMembers?.isOpen) && (
          <CreateNewWorkspaceModal
            workspaceTab={workspaceTab}
            changeWorkspaceTab={setWorkspaceTab}
            isOpen={isManageWorkspaceModal || manageMembers?.isOpen}
            manageMembers={manageMembers}
            onClose={() => {
              setIsManageWorkspaceModal(false);
              setManageMembers({
                id: "",
                isOpen: false,
              });
            }}
            actionType={"edit"}
            workspace={currentWorkspace}
          />
        )}
        <PendingApplicationsModal
          isOpen={showPendingApplicationsModal}
          onClose={closePendingApplicationsModal}
          loading={pendingApplicationsLoading}
          applications={pendingApplicationsData}
          workspaces={allWorkspaces}
          onRefresh={handlePendingApplicationsRefresh}
        />
      </div>
    </>
  );
};

export default Homepage;
